import React, { useState, useRef } from "react";
import {
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  IconButton,
  Typography,
  FormGroup,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Box,
  Button,
} from "@mui/material";
import CardMedia from "@mui/material/CardMedia";
import Stack from "@mui/material/Stack";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import Link from "@mui/material/Link";
import Avatar from "@mui/material/Avatar";
import shadows from "@mui/material/styles/shadows";
import { alpha } from "@mui/material/styles";
import { auth } from "@jumbo/services/auth/firebase/firebase";
import * as yup from "yup";
import { Form, Formik } from "formik";
import { useAuthSignInWithEmailAndPassword } from "@react-query-firebase/auth";
import LoadingButton from "@mui/lab/LoadingButton";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import Div from "@jumbo/shared/Div";
import JumboTextField from "@jumbo/components/JumboFormik/JumboTextField";
import { useJumboApp } from "@jumbo/hooks";
import { LAYOUT_NAMES } from "../../../layouts/layouts";
import { ASSET_AVATARS, ASSET_IMAGES } from "../../../utils/constants/paths";
import { getAssetPath } from "../../../utils/appHelpers";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import FormHelperText from "@mui/material/FormHelperText";
import { useDispatch } from "react-redux";
import {
  fetchError,
  fetchStart,
  fetchSuccess,
} from "../../../redux/actions/Common";

import {
  SignUpCli,
  SignUpCliExistente,
  grabarRegistroCLiente,
  obtenerDatosPreevaluacion,
  obtenerRegistroCliente,
} from "../services/index";
import {
  obtenerSolicitud,
  preevaluacionCliente,
  preevaluacionClienteCredito,
} from "app/modules/app-credito/services/creditoServices";
import InfoPopoverButton from "app/modules/shared/components/InfoPopoverButton";
import { consultarEstadoCredito } from "app/modules/app-transaccional/services/transaccionalService";
import HouseIcon from "@mui/icons-material/House";
import { consultarGrupoGenerico } from "app/modules/app-configuracion/services/configuracionServices";
import { useOnLogout } from "app/modules/app-auth/hook";
import { da } from "date-fns/locale";
import { SCSLoadingButton } from "app/modules/common/components/Buttons/SCSButtons";

let dactilarLocal = "";
const dactilarValidation = (codigo) => {
  let coddactilar = localStorage.getItem("cd");
  const valid = coddactilar == codigo ? true : false;
  //const valid = true;
  return valid
    ? {
        isValid: true,
      }
    : {
        isValid: false,
        errorMessage:
          "Código Dactilar no coincide. Favor comuníquese al numero 3811960",
      };
};

const validationSchema = yup.object({
  // celular: yup
  // .string('Ingrese su celular')
  // //.celular('Ingrese celular válido')
  //.required('Celular es obligatorio'),
  dactilar: yup
    .string("Ingrese Código Dactilar")
    .test("validator-custom-name", function (value) {
      const validation = dactilarValidation(value);
      if (!validation.isValid) {
        return this.createError({
          path: this.path,
          message: validation.errorMessage,
        });
      } else {
        return true;
      }
    })
    .required("Código Dactilar es Obligatorio"),
});

const Datos = () => {
  const dispatch = useDispatch();

  //const origen = localStorage.getItem("origen");
  const [origen, setOrigen] = useState(localStorage.getItem("origen"));
  const cedula = localStorage.getItem("cedula");

  const history = useHistory();
  const { setActiveLayout } = useJumboApp();
  const [open, setOpen] = useState(false);
  const [mensajeCliente, setMensajeCiente] = useState("");
  const [continuaProceso, setContinuaProceso] = useState(false);
  const [color, setColor] = useState("");
  const [url, setUrl] = useState("");
  const { authUser } = useSelector(({ auth }) => auth);

  const [sendLogout, setSendLogout] = useState(false);
  const [userCode, setUserCode] = useState(false);

  const [flujoFinal, setFlujoFinal] = useState("");
  const [datosPreevaluacion, setDatosPreevaluacion] = useState({});
  const [mostrarAprobado, setMostrarAprobado] = useState(false);
  const [mostrarNegado, setMostrarNegado] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [mensajeClienteExpress, setMensajeCienteExpress] = useState("");
  const [montoMG, setMontoMG] = useState(0);

  const isSubmittingRef = useRef(false);

  useOnLogout(userCode, sendLogout, setSendLogout);

  React.useEffect(() => {
    setActiveLayout(LAYOUT_NAMES.SOLO_PAGE);
    switch (origen) {
      case "tvtas":
        setColor("#FF9201");
        setUrl("https://www.tventas.com/content/55-creditventas");
        break;
      case "corpfav":
        setColor("#e1251b");
        setUrl("https://www.creditofavorito.com/");
        break;
      default:
        setColor("#e1251b");
        setUrl("https://www.creditofavorito.com/");
        break;
    }
    const obtenerGrupo = async () => {
      const resp = await consultarGrupoGenerico(origen, 1);
      if (resp.state) {
        localStorage.setItem("idGrupoStorage", resp.data[0].codigo);
      } else {
        console.log(resp.message);
      }
    };

    obtenerGrupo();
  }, []);

  // const obtenerGrupo = async () => {
  //   const resp = await consultarGrupoGenerico(origen, 1);
  //   if (resp.state) {
  //     localStorage.setItem("idGrupoStorage", resp.data[0].codigo);
  //   } else {
  //     console.log(resp.message);
  //   }
  // };

  const mutation = useAuthSignInWithEmailAndPassword(auth, {
    onError(error) {
      console.log(error);
    },
    onSuccess(data) {
      history.push("/", { replace: true });
    },
  });

  const onSignIn = async (dactilar) => {
    console.log("entro");
    let celular = localStorage.getItem("celular");
    let email = localStorage.getItem("email");

    try {
      const srvObtenerDatosSol = await consultarEstadoCredito(
        cedula,
        localStorage.getItem("idGrupoStorage"),
      );

      const esAutoservicio = eval(localStorage.getItem("autoservicio"));
      let usuarioConsulta;
      if (esAutoservicio) {
        usuarioConsulta = localStorage.getItem("nombreMaquina");
      } else {
        usuarioConsulta = `LandingWeb-${origen}`;
      }
      if (!srvObtenerDatosSol.state) {
        let response = await SignUpCli(cedula, celular, dactilar);
        if (response.state) {
          const datosPreev = {
            identificacion: cedula,
            usuario: authUser.key,
            local: authUser.oficina,
            origen: "SCS",
            dactilar: dactilar,
            celular: celular,
            email: email,
            estacion: usuarioConsulta,
          };

          try {
            const resp = await preevaluacionClienteCredito(datosPreev);
            console.log(resp);
            if (resp.state) {
              // console.log(resp);
              const flujoRespuesta = resp.data.datosPreevaluacion.flujoFinal;
              setFlujoFinal(resp.data.datosPreevaluacion.flujoFinal);
              //setMontoSugerido(resp.data.datosMontoSugerido.valor)
              setDatosPreevaluacion(resp.data);
              let monto, montoAbastos;
              switch (flujoRespuesta) {
                case "NEGADO":
                  setMensajeCiente(resp.data.datosPreevaluacion.mensaje);
                  setMostrarNegado(true);
                  setIsLoading(false);
                  isSubmittingRef.current = false;
                  setContinuaProceso(false);
                  setOpen(true);

                  break;
                case "REVISION":
                  monto =
                    resp.data.datosMontoSugerido.valor > 2500
                      ? 2500
                      : resp.data.datosMontoSugerido.valor < 0
                        ? 0
                        : resp.data.datosMontoSugerido.valor;

                  setMensajeCiente(
                    "¡Felicitaciones! Estás a un paso de tener tu Crédito Favorito. Ahora solo falta que completes una validación corta para finalizar el proceso y dejar tu crédito listo para usar",
                  );
                  setMostrarAprobado(true);
                  setIsLoading(false);
                  isSubmittingRef.current = false;
                  setContinuaProceso(true);
                  setOpen(true);

                  break;
                case "EXPRESS":
                  setMontoMG(
                    resp.data.datosMontoSugerido.valor > 2500
                      ? 2500
                      : resp.data.datosMontoSugerido.valor < 0
                        ? 0
                        : resp.data.datosMontoSugerido.valor.toFixed(0),
                  );
                  monto =
                    resp.data.datosMontoSugerido.valor > 2500
                      ? 2500
                      : resp.data.datosMontoSugerido.valor < 0
                        ? 0
                        : resp.data.datosMontoSugerido.valor.toFixed(0);

                  montoAbastos = resp.data.datosMontoSugerido.valorAbastos;
                  const textAbastos =
                    resp.data.datosPreevaluacion.idGrupo === 1
                      ? ` y para Abastos de $${montoAbastos.toFixed(0)}`
                      : ``;
                  setMensajeCiente(
                    `Felicidades tienes un monto aprobado para Mercancias Generales de $${monto}${textAbastos} y puedes usarlos hoy mismo.`,
                  );
                  setMensajeCienteExpress(
                    `Solo te faltan 2 pasos para activarlo y empezar a comprar, Confirma tu identidad y Personaliza las condiciones de tu crédito`,
                  );
                  setMostrarAprobado(true);
                  setIsLoading(false);
                  isSubmittingRef.current = false;
                  setContinuaProceso(true);
                  setOpen(true);

                  break;
                case "DEVUELTA":
                  setMensajeCiente(resp.data.datosPreevaluacion.mensaje);
                  setMostrarAprobado(true);
                  setIsLoading(false);
                  isSubmittingRef.current = false;
                  setContinuaProceso(true);
                  setOpen(true);

                  break;
                case "SolicitudActiva":
                  setMensajeCiente(resp.data.datosPreevaluacion.mensaje);
                  setMostrarNegado(true);
                  setIsLoading(false);
                  isSubmittingRef.current = false;
                  setContinuaProceso(false);
                  setOpen(true);

                  break;
                default:
                  setMensajeCiente(
                    "En estos momentos no podemos realizar su Evaluación por favor intente en unos minutos.",
                  );
                  setMostrarNegado(true);
                  setIsLoading(false);
                  isSubmittingRef.current = false;
                  setContinuaProceso(false);
                  setOpen(true);

                  break;
              }

              // if (resp.data.validacion) {
              //   //console.log(resp.data.mensaje);
              //   setMensajeCiente(resp.data.mensaje);
              //   setMostrarAprobado(true);
              //   setLoadingPreevaluar(false);
              // } else {
              //   setMensajeCiente(resp.data.mensaje);
              //   setMostrarNegado(true);
              //   setLoadingPreevaluar(false);
              // }
            } else {
              console.log(resp.message);
              setMensajeCiente(
                "En estos momentos no podemos realizar su Evaluación por favor intente en unos minutos.(P)",
              );
              setIsLoading(false);
              isSubmittingRef.current = false;
              setContinuaProceso(false);
              setOpen(true);
            }
          } catch (e) {
            console.log(e);
            setMensajeCiente(
              "En estos momentos no podemos realizar su Evaluación por favor intente en unos minutos.(E)",
            );
            setIsLoading(false);
            isSubmittingRef.current = false;
            setContinuaProceso(false);
            setOpen(true);
          }
        }
      } else {
        alert("Cliente ya existe por favor inicie Sesion");
        //debugger;
        let response = await SignUpCliExistente(cedula, celular, dactilar);
        if (response.state) {
          try {
            let idCliente;
            let idFlujo;
            const rspCli = await obtenerDatosPreevaluacion(
              cedula,
              authUser.key,
            );
            if (rspCli.state) {
              idCliente = rspCli.data.idCliente;
              const rspSolicitud = await obtenerSolicitud(
                rspCli.data.idSolicitud,
              );
              if (rspSolicitud.state) {
                idFlujo = rspSolicitud.data.idFlujo;
              }
            }

            const srvRegistroCliente = await obtenerRegistroCliente(
              cedula,
              localStorage.getItem("idGrupoStorage"),
            );
            if (srvRegistroCliente.state) {
              let registro = srvRegistroCliente.data;
              registro.secuencia = 6;
              registro.procesado = true;
              registro.idCliente = idCliente;
              registro.idFlujo = idFlujo;
              try {
                var srvGrabarRegistro = await grabarRegistroCLiente(registro);
              } catch (e) {
                //console.log(e);
              }
            }
          } catch (e) {
            //console.log(e.message);
          }

          history.push("/signincli");
        }
      }
    } catch (e) {
      console.log(e.message);
    }

    //mutation.mutate({email, password});
  };

  const routeChange = (cambioCupo) => {
    const path = "/credito/flujop";
    history.push(path, {
      data: {
        identificacion: cedula,
        flujoFinal: flujoFinal,
        cambioCupo: cambioCupo,
        datosPreevaluacion: datosPreevaluacion,
      },
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleRedirect = () => {
    /*     setSend(false);
    setMostrarRefresh(false);
    setesperaLogin(false);
    setLoggedUser(false);
    localStorage.removeItem("tipocliente");
    localStorage.removeItem("idGrupoStorage");
    localStorage.removeItem("cedula");
    localStorage.removeItem("origen"); */

    const urlAutoservice = process.env.REACT_APP_URL_AUTOSERVICE;

    if (localStorage.getItem("station") === "autosrv") {
      setSendLogout(true);
      window.opener = null;
      window.open(urlAutoservice, "_self");
      window.close();
    } else {
      window.open(url, "_self");
    }
  };

  return (
    <Div
      sx={{
        flex: 1,
        marginTop: 20,
        flexWrap: "wrap",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: (theme) => theme.spacing(4),
      }}
    >
      <Box
        component="img"
        src={`${process.env.REACT_APP_IMAGES_PATH}/logo-${origen}.png`}
        sx={{
          justifyContent: "center",
          width: 350,
          height: 140,
        }}
      />
      <Card sx={{ maxWidth: "100%", width: 360, mb: 4 }}>
        <Div sx={{ position: "relative", height: "200px" }}>
          <CardMedia
            component="img"
            height="200"
            sx={{ backgroundColor: color }}
          />
          <Div
            sx={{
              flex: 1,
              inset: 0,
              position: "absolute",
              display: "flex",
              alignItems: "center",
              p: (theme) => theme.spacing(3),
            }}
          >
            <Typography
              variant={"h2"}
              sx={{
                color: "common.white",
                fontSize: "1.5rem",
                mb: 0,
              }}
            >
              Registro de Datos
            </Typography>
          </Div>
        </Div>
        <CardContent sx={{ pt: 0 }}>
          <Formik
            validateOnChange={true}
            initialValues={{
              dactilar: "",
            }}
            validationSchema={validationSchema}
            onSubmit={async (data, { setSubmitting }) => {
              if (isSubmittingRef.current) return;
              isSubmittingRef.current = true;

              setIsLoading(true);
              dactilarLocal = data.dactilar;

              try {
                await onSignIn(data.dactilar);

                setIsLoading(false);
              } catch (error) {
                isSubmittingRef.current = false;
                setIsLoading(false);
              }
            }}
          >
            {({ isSubmitting }) => (
              <Form style={{ textAlign: "left" }} noValidate autoComplete="off">
                <Div sx={{ mb: 2, mt: 1, marginTop: 5 }}>
                  <Typography>
                    Ingresa tu Código Dactilar
                    <InfoPopoverButton
                      nombre={"CD"}
                      texto={`<p> El codigo Dactilar se encuentra impreso en el reverso <br/>de la cédula de identidad, en la parte superior derecha</p>`}
                    >
                      <Stack alignItems={"center"} justifyContent={"center"}>
                        <Box
                          component="img"
                          src={`${process.env.REACT_APP_IMAGES_PATH}/dactilar.jpg`}
                          sx={{
                            justifyContent: "center",
                            width: 360,
                            height: 192,
                            mb: 3,
                          }}
                        />
                      </Stack>
                    </InfoPopoverButton>
                    <br />
                    <br />
                  </Typography>
                  <JumboTextField
                    fullWidth
                    name="dactilar"
                    //label="Código Dactilar"
                    //type="password"
                    focused={true}
                    sx={{ mb: 5 }}
                  />
                </Div>

                <SCSLoadingButton
                  loading={isLoading || mutation.isLoading}
                  titulo="Continuar"
                  fullWidth
                ></SCSLoadingButton>
              </Form>
            )}
          </Formik>
        </CardContent>
      </Card>

      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: 4,
            overflow: "hidden",
          },
        }}
      >
        <DialogContent
          sx={{
            backgroundColor: "#e9f0ffff",
            borderRadius: 4,
            p: 3,
          }}
        >
          <Card
            elevation={0}
            sx={{
              backgroundColor: "transparent",
              boxShadow: "none",
            }}
          >
            <CardContent>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                flexWrap="wrap"
              >
                <Box flex="1" minWidth="220px">
                  <Typography
                    variant="h2"
                    fontWeight="bold"
                    color="text.primary"
                    // gutterBottom
                  >
                    {continuaProceso
                      ? "EVALUACION EXITOSA"
                      : "EVALUACION NO EXITOSA"}
                  </Typography>
                  <Typography variant="h3" color="text.secondary" mb={2} mt={5}>
                    {mensajeCliente}
                  </Typography>
                  <Typography variant="h3" color="text.secondary" mb={2} mt={5}>
                    {mensajeClienteExpress}
                  </Typography>
                  {continuaProceso && (
                    <Stack direction={"row"} spacing={2} mt={8}>
                      <Button
                        variant="contained"
                        onClick={() => {
                          routeChange(false);
                        }}
                        sx={{
                          backgroundColor: "#FFFFFF",
                          color: "#000",
                          textTransform: "none",
                          fontWeight: "bold",
                          boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                          "&:hover": { backgroundColor: "#f5f5f5" },
                          borderRadius: "9999px", // 🔘 redondeado tipo píldora
                          px: 3, // padding horizontal extra
                          "&:hover": { backgroundColor: "#f5f5f5" },
                        }}
                      >
                        Continuar
                      </Button>
                    </Stack>
                  )}
                </Box>

                {/* Imagen del personaje rojo */}
                <Box
                  component="img"
                  src={`/images/logo-preev-${authUser.usuarioFlujos[0].idGrupo}.png`}
                  alt="Figura roja"
                  sx={{
                    width: 175,
                    height: "auto",
                    ml: 2,
                    mt: { xs: 2, sm: 0 },
                  }}
                />
              </Box>
            </CardContent>
          </Card>
        </DialogContent>
      </Dialog>
      <Button
        size="lg"
        variant="outlined"
        startIcon={<HouseIcon />}
        onClick={() => handleRedirect()}
      >
        <Typography> Regresar a la pagina Principal</Typography>
      </Button>
    </Div>
  );
};

export default Datos;
